import { Triangle } from "react-loader-spinner";

export const Loader = () => {
    return (
      <Triangle
        height="40"
        width="40"
        color="#dbc097"
        ariaLabel="triangle-loading"
        wrapperStyle={{}}
        visible={true}
      />
    );
  };